export class ServiceView {

  id: string;
  userId: string;
  viewDate_Time: Date;
  serviceId: string;

}
